/**
 * Basic route file, duplicate and rename depending if additional routes are required.
 * Note that the body class should match the file name.
 */

/* Import External Modules */
import Cookies from 'js-cookie';

/* Import Internal Modules */
import Accessibility from '../global/_accessibility';
import Navigation from '../global/_navigation';
import { siteHeader } from '../global/_site-header';
import videoControls from '../component/_video-controls';

/* Import Utils */
import { scrollListener, resizeListener } from '../util/_utilities';

/* Import Styles */
import styles from '../..//sass/main.scss';

export default {
    init () {
        // JavaScript to be fired on all pages
        Cookies;
        siteHeader();
        Navigation.init();
        Accessibility.init();
        videoControls.init('.rs-video .rs-play', '.embed-container .rs-play');

        // ---------- Mobile Menu ----------
        jQuery('.item_has_children > a').on('click', function (e) {
            e.preventDefault();
        });
        // ---------- Mobile Menu ----------

        // ---------- Mobile Menu ----------
        jQuery('.rs-mobile__menu-item.item_has_children > a').on('click', function (e) {
            e.preventDefault();
            jQuery(this).siblings('.rs-mobile__sub-menu').addClass('active');
            jQuery('.rs-mobile__cta').addClass('hide');
        });
        jQuery('.rs-mobile__back').on('click', function () {
            jQuery(this).closest('.rs-mobile__sub-menu').removeClass('active');
            jQuery('.rs-mobile__cta').removeClass('hide');
        });
        // ---------- Mobile Menu ----------
    },
    finalize () {
        // JavaScript to be fired on all pages, after page specific JS is fired
    }
};
